// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file organization_settings.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AuditLogType, AuditLogTypeJson } from "./audit_logs_pb";
import { file_audit_logs } from "./audit_logs_pb";
import type { JobType, JobTypeJson, UserRole, UserRoleJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { NotificationChannel, NotificationChannelJson, NotificationEvent, NotificationEventJson } from "./notification_pb";
import { file_notification } from "./notification_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file organization_settings.proto.
 */
export const file_organization_settings: GenFile = /*@__PURE__*/
  fileDesc("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", [file_audit_logs, file_enums, file_google_protobuf_timestamp, file_notification]);

/**
 * Who gets notified about an event, through which channels, and whether they
 * may mute it. audience accepts USER_ROLE_RECEIVER_USER, USER_ROLE_DRIVER,
 * USER_ROLE_PROVIDER_MECHANIC and USER_ROLE_PROVIDER_DISPATCHER; other roles
 * are rejected until they have a recipient resolver.
 *
 * @generated from message raccoonai.NotificationRule
 */
export type NotificationRule = Message<"raccoonai.NotificationRule"> & {
  /**
   * @generated from field: required raccoonai.NotificationEvent event = 1;
   */
  event: NotificationEvent;

  /**
   * @generated from field: required raccoonai.UserRole audience = 2;
   */
  audience: UserRole;

  /**
   * at least one
   *
   * @generated from field: repeated raccoonai.NotificationChannel channels = 3;
   */
  channels: NotificationChannel[];

  /**
   * @generated from field: required bool opt_out_allowed = 4 [json_name = "opt_out_allowed"];
   */
  optOutAllowed: boolean;
};

/**
 * Who gets notified about an event, through which channels, and whether they
 * may mute it. audience accepts USER_ROLE_RECEIVER_USER, USER_ROLE_DRIVER,
 * USER_ROLE_PROVIDER_MECHANIC and USER_ROLE_PROVIDER_DISPATCHER; other roles
 * are rejected until they have a recipient resolver.
 *
 * @generated from message raccoonai.NotificationRule
 */
export type NotificationRuleJson = {
  /**
   * @generated from field: required raccoonai.NotificationEvent event = 1;
   */
  event?: NotificationEventJson;

  /**
   * @generated from field: required raccoonai.UserRole audience = 2;
   */
  audience?: UserRoleJson;

  /**
   * at least one
   *
   * @generated from field: repeated raccoonai.NotificationChannel channels = 3;
   */
  channels?: NotificationChannelJson[];

  /**
   * @generated from field: required bool opt_out_allowed = 4 [json_name = "opt_out_allowed"];
   */
  opt_out_allowed?: boolean;
};

/**
 * Describes the message raccoonai.NotificationRule.
 * Use `create(NotificationRuleSchema)` to create a new message.
 */
export const NotificationRuleSchema: GenMessage<NotificationRule, {jsonType: NotificationRuleJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 0);

/**
 * Wrapped so an empty list stays present on update: absent = built-in
 * defaults, present with no rules = all notifications off.
 *
 * @generated from message raccoonai.NotificationRules
 */
export type NotificationRules = Message<"raccoonai.NotificationRules"> & {
  /**
   * unique per (event, audience)
   *
   * @generated from field: repeated raccoonai.NotificationRule rules = 1;
   */
  rules: NotificationRule[];
};

/**
 * Wrapped so an empty list stays present on update: absent = built-in
 * defaults, present with no rules = all notifications off.
 *
 * @generated from message raccoonai.NotificationRules
 */
export type NotificationRulesJson = {
  /**
   * unique per (event, audience)
   *
   * @generated from field: repeated raccoonai.NotificationRule rules = 1;
   */
  rules?: NotificationRuleJson[];
};

/**
 * Describes the message raccoonai.NotificationRules.
 * Use `create(NotificationRulesSchema)` to create a new message.
 */
export const NotificationRulesSchema: GenMessage<NotificationRules, {jsonType: NotificationRulesJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 1);

/**
 * @generated from message raccoonai.NotificationConfig
 */
export type NotificationConfig = Message<"raccoonai.NotificationConfig"> & {
  /**
   * Audit-log view filter. Superseded by rules; kept for the current frontend.
   *
   * @generated from field: repeated raccoonai.AuditLogType log_types = 1 [json_name = "log_types"];
   */
  logTypes: AuditLogType[];

  /**
   * GetSetting always returns the effective rules (defaults when none stored).
   *
   * @generated from field: optional raccoonai.NotificationRules rules = 2;
   */
  rules?: NotificationRules;
};

/**
 * @generated from message raccoonai.NotificationConfig
 */
export type NotificationConfigJson = {
  /**
   * Audit-log view filter. Superseded by rules; kept for the current frontend.
   *
   * @generated from field: repeated raccoonai.AuditLogType log_types = 1 [json_name = "log_types"];
   */
  log_types?: AuditLogTypeJson[];

  /**
   * GetSetting always returns the effective rules (defaults when none stored).
   *
   * @generated from field: optional raccoonai.NotificationRules rules = 2;
   */
  rules?: NotificationRulesJson;
};

/**
 * Describes the message raccoonai.NotificationConfig.
 * Use `create(NotificationConfigSchema)` to create a new message.
 */
export const NotificationConfigSchema: GenMessage<NotificationConfig, {jsonType: NotificationConfigJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 2);

/**
 * @generated from message raccoonai.ColumnConfig
 */
export type ColumnConfig = Message<"raccoonai.ColumnConfig"> & {
  /**
   * @generated from field: required string column_name = 1 [json_name = "column_name"];
   */
  columnName: string;

  /**
   * @generated from field: required bool is_hidden = 2 [json_name = "is_hidden"];
   */
  isHidden: boolean;

  /**
   * @generated from field: required uint32 order = 3;
   */
  order: number;

  /**
   * @generated from field: optional uint32 width = 4;
   */
  width: number;
};

/**
 * @generated from message raccoonai.ColumnConfig
 */
export type ColumnConfigJson = {
  /**
   * @generated from field: required string column_name = 1 [json_name = "column_name"];
   */
  column_name?: string;

  /**
   * @generated from field: required bool is_hidden = 2 [json_name = "is_hidden"];
   */
  is_hidden?: boolean;

  /**
   * @generated from field: required uint32 order = 3;
   */
  order?: number;

  /**
   * @generated from field: optional uint32 width = 4;
   */
  width?: number;
};

/**
 * Describes the message raccoonai.ColumnConfig.
 * Use `create(ColumnConfigSchema)` to create a new message.
 */
export const ColumnConfigSchema: GenMessage<ColumnConfig, {jsonType: ColumnConfigJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 3);

/**
 * @generated from message raccoonai.TableConfig
 */
export type TableConfig = Message<"raccoonai.TableConfig"> & {
  /**
   * @generated from field: required string table_name = 1 [json_name = "table_name"];
   */
  tableName: string;

  /**
   * @generated from field: repeated raccoonai.ColumnConfig columns = 2;
   */
  columns: ColumnConfig[];
};

/**
 * @generated from message raccoonai.TableConfig
 */
export type TableConfigJson = {
  /**
   * @generated from field: required string table_name = 1 [json_name = "table_name"];
   */
  table_name?: string;

  /**
   * @generated from field: repeated raccoonai.ColumnConfig columns = 2;
   */
  columns?: ColumnConfigJson[];
};

/**
 * Describes the message raccoonai.TableConfig.
 * Use `create(TableConfigSchema)` to create a new message.
 */
export const TableConfigSchema: GenMessage<TableConfig, {jsonType: TableConfigJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 4);

/**
 * @generated from message raccoonai.TableColumnsConfig
 */
export type TableColumnsConfig = Message<"raccoonai.TableColumnsConfig"> & {
  /**
   * @generated from field: repeated raccoonai.TableConfig tables = 1;
   */
  tables: TableConfig[];
};

/**
 * @generated from message raccoonai.TableColumnsConfig
 */
export type TableColumnsConfigJson = {
  /**
   * @generated from field: repeated raccoonai.TableConfig tables = 1;
   */
  tables?: TableConfigJson[];
};

/**
 * Describes the message raccoonai.TableColumnsConfig.
 * Use `create(TableColumnsConfigSchema)` to create a new message.
 */
export const TableColumnsConfigSchema: GenMessage<TableColumnsConfig, {jsonType: TableColumnsConfigJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 5);

/**
 * Wrapped in a message so an empty selection stays present on update: a bare
 * repeated field marshals to nothing and the merge would keep the old selection.
 *
 * @generated from message raccoonai.DisposalSiteOrgIds
 */
export type DisposalSiteOrgIds = Message<"raccoonai.DisposalSiteOrgIds"> & {
  /**
   * @generated from field: repeated uint64 ids = 1;
   */
  ids: bigint[];
};

/**
 * Wrapped in a message so an empty selection stays present on update: a bare
 * repeated field marshals to nothing and the merge would keep the old selection.
 *
 * @generated from message raccoonai.DisposalSiteOrgIds
 */
export type DisposalSiteOrgIdsJson = {
  /**
   * @generated from field: repeated uint64 ids = 1;
   */
  ids?: string[];
};

/**
 * Describes the message raccoonai.DisposalSiteOrgIds.
 * Use `create(DisposalSiteOrgIdsSchema)` to create a new message.
 */
export const DisposalSiteOrgIdsSchema: GenMessage<DisposalSiteOrgIds, {jsonType: DisposalSiteOrgIdsJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 6);

/**
 * Job types the service provider does not offer. Absent or empty = all enabled.
 * Read via GetSetting, written via OrganizationService.UpdateDisabledJobTypes.
 *
 * @generated from message raccoonai.DisabledJobTypes
 */
export type DisabledJobTypes = Message<"raccoonai.DisabledJobTypes"> & {
  /**
   * @generated from field: repeated raccoonai.JobType types = 1;
   */
  types: JobType[];
};

/**
 * Job types the service provider does not offer. Absent or empty = all enabled.
 * Read via GetSetting, written via OrganizationService.UpdateDisabledJobTypes.
 *
 * @generated from message raccoonai.DisabledJobTypes
 */
export type DisabledJobTypesJson = {
  /**
   * @generated from field: repeated raccoonai.JobType types = 1;
   */
  types?: JobTypeJson[];
};

/**
 * Describes the message raccoonai.DisabledJobTypes.
 * Use `create(DisabledJobTypesSchema)` to create a new message.
 */
export const DisabledJobTypesSchema: GenMessage<DisabledJobTypes, {jsonType: DisabledJobTypesJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 7);

/**
 * @generated from message raccoonai.OrganizationSettings
 */
export type OrganizationSettings = Message<"raccoonai.OrganizationSettings"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string shift_departure_text = 3 [json_name = "shift_departure_text"];
   */
  shiftDepartureText: string;

  /**
   * @generated from field: optional string shift_arrival_text = 4 [json_name = "shift_arrival_text"];
   */
  shiftArrivalText: string;

  /**
   * @generated from field: optional string shift_working_schedule = 5 [json_name = "shift_working_schedule"];
   */
  shiftWorkingSchedule: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 6 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required bool is_ai_driven = 7 [json_name = "is_ai_driven"];
   */
  isAiDriven: boolean;

  /**
   * @generated from field: optional raccoonai.NotificationConfig notification_config = 8 [json_name = "notification_config"];
   */
  notificationConfig?: NotificationConfig;

  /**
   * @generated from field: optional double map_center_lat = 9 [json_name = "map_center_lat"];
   */
  mapCenterLat: number;

  /**
   * @generated from field: optional double map_center_lon = 10 [json_name = "map_center_lon"];
   */
  mapCenterLon: number;

  /**
   * @generated from field: optional bool ai_enabled = 11 [json_name = "ai_enabled"];
   */
  aiEnabled: boolean;

  /**
   * @generated from field: optional raccoonai.TableColumnsConfig table_columns_config = 12 [json_name = "table_columns_config"];
   */
  tableColumnsConfig?: TableColumnsConfig;

  /**
   * @generated from field: optional double reward_coeff = 13 [json_name = "reward_coeff"];
   */
  rewardCoeff: number;

  /**
   * @generated from field: optional uint64 default_depot_id = 15 [json_name = "default_depot_id"];
   */
  defaultDepotId: bigint;

  /**
   * @generated from field: optional raccoonai.DisposalSiteOrgIds disposal_site_org_ids = 16 [json_name = "disposal_site_org_ids"];
   */
  disposalSiteOrgIds?: DisposalSiteOrgIds;

  /**
   * @generated from field: optional raccoonai.DisabledJobTypes disabled_job_types = 17 [json_name = "disabled_job_types"];
   */
  disabledJobTypes?: DisabledJobTypes;

  /**
   * responsible zones apply to the organization and its subtree
   *
   * @generated from field: optional bool responsible_zone_enabled = 18 [json_name = "responsible_zone_enabled"];
   */
  responsibleZoneEnabled: boolean;
};

/**
 * @generated from message raccoonai.OrganizationSettings
 */
export type OrganizationSettingsJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string shift_departure_text = 3 [json_name = "shift_departure_text"];
   */
  shift_departure_text?: string;

  /**
   * @generated from field: optional string shift_arrival_text = 4 [json_name = "shift_arrival_text"];
   */
  shift_arrival_text?: string;

  /**
   * @generated from field: optional string shift_working_schedule = 5 [json_name = "shift_working_schedule"];
   */
  shift_working_schedule?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 6 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required bool is_ai_driven = 7 [json_name = "is_ai_driven"];
   */
  is_ai_driven?: boolean;

  /**
   * @generated from field: optional raccoonai.NotificationConfig notification_config = 8 [json_name = "notification_config"];
   */
  notification_config?: NotificationConfigJson;

  /**
   * @generated from field: optional double map_center_lat = 9 [json_name = "map_center_lat"];
   */
  map_center_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double map_center_lon = 10 [json_name = "map_center_lon"];
   */
  map_center_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional bool ai_enabled = 11 [json_name = "ai_enabled"];
   */
  ai_enabled?: boolean;

  /**
   * @generated from field: optional raccoonai.TableColumnsConfig table_columns_config = 12 [json_name = "table_columns_config"];
   */
  table_columns_config?: TableColumnsConfigJson;

  /**
   * @generated from field: optional double reward_coeff = 13 [json_name = "reward_coeff"];
   */
  reward_coeff?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 default_depot_id = 15 [json_name = "default_depot_id"];
   */
  default_depot_id?: string;

  /**
   * @generated from field: optional raccoonai.DisposalSiteOrgIds disposal_site_org_ids = 16 [json_name = "disposal_site_org_ids"];
   */
  disposal_site_org_ids?: DisposalSiteOrgIdsJson;

  /**
   * @generated from field: optional raccoonai.DisabledJobTypes disabled_job_types = 17 [json_name = "disabled_job_types"];
   */
  disabled_job_types?: DisabledJobTypesJson;

  /**
   * responsible zones apply to the organization and its subtree
   *
   * @generated from field: optional bool responsible_zone_enabled = 18 [json_name = "responsible_zone_enabled"];
   */
  responsible_zone_enabled?: boolean;
};

/**
 * Describes the message raccoonai.OrganizationSettings.
 * Use `create(OrganizationSettingsSchema)` to create a new message.
 */
export const OrganizationSettingsSchema: GenMessage<OrganizationSettings, {jsonType: OrganizationSettingsJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 8);

/**
 * @generated from message raccoonai.OrganizationSettingsCreate
 */
export type OrganizationSettingsCreate = Message<"raccoonai.OrganizationSettingsCreate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string shift_departure_text = 2 [json_name = "shift_departure_text"];
   */
  shiftDepartureText: string;

  /**
   * @generated from field: optional string shift_arrival_text = 3 [json_name = "shift_arrival_text"];
   */
  shiftArrivalText: string;

  /**
   * @generated from field: optional string shift_working_schedule = 4 [json_name = "shift_working_schedule"];
   */
  shiftWorkingSchedule: string;

  /**
   * @generated from field: optional bool is_ai_driven = 5 [json_name = "is_ai_driven"];
   */
  isAiDriven: boolean;

  /**
   * @generated from field: optional raccoonai.NotificationConfig notification_config = 6 [json_name = "notification_config"];
   */
  notificationConfig?: NotificationConfig;

  /**
   * @generated from field: optional double map_center_lat = 7 [json_name = "map_center_lat"];
   */
  mapCenterLat: number;

  /**
   * @generated from field: optional double map_center_lon = 8 [json_name = "map_center_lon"];
   */
  mapCenterLon: number;

  /**
   * @generated from field: optional bool ai_enabled = 9 [json_name = "ai_enabled"];
   */
  aiEnabled: boolean;

  /**
   * @generated from field: optional raccoonai.TableColumnsConfig table_columns_config = 10 [json_name = "table_columns_config"];
   */
  tableColumnsConfig?: TableColumnsConfig;

  /**
   * @generated from field: optional uint64 default_depot_id = 12 [json_name = "default_depot_id"];
   */
  defaultDepotId: bigint;

  /**
   * @generated from field: optional raccoonai.DisposalSiteOrgIds disposal_site_org_ids = 13 [json_name = "disposal_site_org_ids"];
   */
  disposalSiteOrgIds?: DisposalSiteOrgIds;

  /**
   * admin only
   *
   * @generated from field: optional bool responsible_zone_enabled = 15 [json_name = "responsible_zone_enabled"];
   */
  responsibleZoneEnabled: boolean;
};

/**
 * @generated from message raccoonai.OrganizationSettingsCreate
 */
export type OrganizationSettingsCreateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string shift_departure_text = 2 [json_name = "shift_departure_text"];
   */
  shift_departure_text?: string;

  /**
   * @generated from field: optional string shift_arrival_text = 3 [json_name = "shift_arrival_text"];
   */
  shift_arrival_text?: string;

  /**
   * @generated from field: optional string shift_working_schedule = 4 [json_name = "shift_working_schedule"];
   */
  shift_working_schedule?: string;

  /**
   * @generated from field: optional bool is_ai_driven = 5 [json_name = "is_ai_driven"];
   */
  is_ai_driven?: boolean;

  /**
   * @generated from field: optional raccoonai.NotificationConfig notification_config = 6 [json_name = "notification_config"];
   */
  notification_config?: NotificationConfigJson;

  /**
   * @generated from field: optional double map_center_lat = 7 [json_name = "map_center_lat"];
   */
  map_center_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double map_center_lon = 8 [json_name = "map_center_lon"];
   */
  map_center_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional bool ai_enabled = 9 [json_name = "ai_enabled"];
   */
  ai_enabled?: boolean;

  /**
   * @generated from field: optional raccoonai.TableColumnsConfig table_columns_config = 10 [json_name = "table_columns_config"];
   */
  table_columns_config?: TableColumnsConfigJson;

  /**
   * @generated from field: optional uint64 default_depot_id = 12 [json_name = "default_depot_id"];
   */
  default_depot_id?: string;

  /**
   * @generated from field: optional raccoonai.DisposalSiteOrgIds disposal_site_org_ids = 13 [json_name = "disposal_site_org_ids"];
   */
  disposal_site_org_ids?: DisposalSiteOrgIdsJson;

  /**
   * admin only
   *
   * @generated from field: optional bool responsible_zone_enabled = 15 [json_name = "responsible_zone_enabled"];
   */
  responsible_zone_enabled?: boolean;
};

/**
 * Describes the message raccoonai.OrganizationSettingsCreate.
 * Use `create(OrganizationSettingsCreateSchema)` to create a new message.
 */
export const OrganizationSettingsCreateSchema: GenMessage<OrganizationSettingsCreate, {jsonType: OrganizationSettingsCreateJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 9);

/**
 * @generated from message raccoonai.OrganizationSettingsUpdate
 */
export type OrganizationSettingsUpdate = Message<"raccoonai.OrganizationSettingsUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string shift_departure_text = 2 [json_name = "shift_departure_text"];
   */
  shiftDepartureText: string;

  /**
   * @generated from field: optional string shift_arrival_text = 3 [json_name = "shift_arrival_text"];
   */
  shiftArrivalText: string;

  /**
   * @generated from field: optional string shift_working_schedule = 4 [json_name = "shift_working_schedule"];
   */
  shiftWorkingSchedule: string;

  /**
   * @generated from field: optional bool is_ai_driven = 5 [json_name = "is_ai_driven"];
   */
  isAiDriven: boolean;

  /**
   * @generated from field: optional raccoonai.NotificationConfig notification_config = 6 [json_name = "notification_config"];
   */
  notificationConfig?: NotificationConfig;

  /**
   * @generated from field: optional double map_center_lat = 7 [json_name = "map_center_lat"];
   */
  mapCenterLat: number;

  /**
   * @generated from field: optional double map_center_lon = 8 [json_name = "map_center_lon"];
   */
  mapCenterLon: number;

  /**
   * @generated from field: optional bool ai_enabled = 9 [json_name = "ai_enabled"];
   */
  aiEnabled: boolean;

  /**
   * @generated from field: optional raccoonai.TableColumnsConfig table_columns_config = 10 [json_name = "table_columns_config"];
   */
  tableColumnsConfig?: TableColumnsConfig;

  /**
   * @generated from field: optional uint64 default_depot_id = 12 [json_name = "default_depot_id"];
   */
  defaultDepotId: bigint;

  /**
   * @generated from field: optional raccoonai.DisposalSiteOrgIds disposal_site_org_ids = 13 [json_name = "disposal_site_org_ids"];
   */
  disposalSiteOrgIds?: DisposalSiteOrgIds;

  /**
   * admin only
   *
   * @generated from field: optional bool responsible_zone_enabled = 15 [json_name = "responsible_zone_enabled"];
   */
  responsibleZoneEnabled: boolean;
};

/**
 * @generated from message raccoonai.OrganizationSettingsUpdate
 */
export type OrganizationSettingsUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string shift_departure_text = 2 [json_name = "shift_departure_text"];
   */
  shift_departure_text?: string;

  /**
   * @generated from field: optional string shift_arrival_text = 3 [json_name = "shift_arrival_text"];
   */
  shift_arrival_text?: string;

  /**
   * @generated from field: optional string shift_working_schedule = 4 [json_name = "shift_working_schedule"];
   */
  shift_working_schedule?: string;

  /**
   * @generated from field: optional bool is_ai_driven = 5 [json_name = "is_ai_driven"];
   */
  is_ai_driven?: boolean;

  /**
   * @generated from field: optional raccoonai.NotificationConfig notification_config = 6 [json_name = "notification_config"];
   */
  notification_config?: NotificationConfigJson;

  /**
   * @generated from field: optional double map_center_lat = 7 [json_name = "map_center_lat"];
   */
  map_center_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double map_center_lon = 8 [json_name = "map_center_lon"];
   */
  map_center_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional bool ai_enabled = 9 [json_name = "ai_enabled"];
   */
  ai_enabled?: boolean;

  /**
   * @generated from field: optional raccoonai.TableColumnsConfig table_columns_config = 10 [json_name = "table_columns_config"];
   */
  table_columns_config?: TableColumnsConfigJson;

  /**
   * @generated from field: optional uint64 default_depot_id = 12 [json_name = "default_depot_id"];
   */
  default_depot_id?: string;

  /**
   * @generated from field: optional raccoonai.DisposalSiteOrgIds disposal_site_org_ids = 13 [json_name = "disposal_site_org_ids"];
   */
  disposal_site_org_ids?: DisposalSiteOrgIdsJson;

  /**
   * admin only
   *
   * @generated from field: optional bool responsible_zone_enabled = 15 [json_name = "responsible_zone_enabled"];
   */
  responsible_zone_enabled?: boolean;
};

/**
 * Describes the message raccoonai.OrganizationSettingsUpdate.
 * Use `create(OrganizationSettingsUpdateSchema)` to create a new message.
 */
export const OrganizationSettingsUpdateSchema: GenMessage<OrganizationSettingsUpdate, {jsonType: OrganizationSettingsUpdateJson}> = /*@__PURE__*/
  messageDesc(file_organization_settings, 10);

